<template>
  <section class="home-subscribe-form-parent">
    <div class="home-subscribe-form-block">
      <section class="top-border"/>
      <section class="home-subscribe-form-innerblock blog">
        <h1>{{ $t('home-page.subscribe.read-more') }}</h1>

        <hr class="hr-grey">

        <p>{{ $t('home-page.subscribe.card-paragraph') }}</p>

        <s-button class="button-primary-dark" btn-link="/">{{$t('actions.visit-blog')}}</s-button>
      </section>

      <section class="home-subscribe-form-innerblock subscribe">

        <form class="home-subscribe-form" name="Password-form" data-name="Password Form">
          <input type="email" class="form-input" placeholder="your@email.com" maxlength="256" name="" required="">
          <small>{{ $t('home-page.subscribe.agree') }}
            <a href="/termsofuse" target="_blank" rel="noopener">{{ $t('home-page.subscribe.terms') }}</a>
            {{ $t('home-page.subscribe.and') }}
            <a href="/privacypolicy" target="_blank">{{ $t('home-page.subscribe.policy') }}</a>.
          </small>
        </form>

        <s-button class="button-secondary" btn-link="/">{{$t('actions.subscribe')}}</s-button>
      </section>
    </div>

  </section>
</template>
<script>

import SButton from "@/components/SButton.vue";

export default {
  name: 'SignUpForm',
  components: {
    SButton,
  },
  props: {
    msg: String
  }
}
</script>
